import React, { Component, useEffect, useState } from 'react';
import styled from 'styled-components';
import img_intro from '../../assets/RJ/RJ_intro.jpg';
import { Container, MainContent, Footer, PaperBorder } from '../../components';
import { Countdown, Places, Bible, Music, Bank, Attendance, Thanks, Photos } from './components';
import { CommonContainer, PendingModule, RaquelyJuan, BackgroundImage, FooterImg } from './partials';

const Invitation = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = img_intro;
    img.onload = () => setIsLoaded(true);
  }, []);

  if (!isLoaded) return null;

  return (
    <Container>
      <MainContent>
        <BackgroundImage marginBottom={10}>
          <RaquelyJuan withShadow />
        </BackgroundImage>

        <Bible />

        <CommonContainer>
          <Countdown />
          {/* TODO: Ese día parar countdown y poner gif de es hoy es hoy */}
          {/* <div id="asistencia">
            <Attendance />
          </div> */}
          {/* TODO: Cargar asistencia guardada en BBDD */}
          {/* TODO: No dejar salir de la página con cambios no guardados */}

          <Places />

          {/* <Bank /> */}

          <Music />

          <Photos />

          <FooterImg />
        </CommonContainer>

        <Footer />
      </MainContent>
    </Container>
  );
};

export default Invitation;
